import Ext from "Ext"
import $ from 'jquery'
import {getBodyScrollTop} from "../../atBrowserUtils";
import AtMap from "../../util/AtMap";

const SharedUserButtonMenu = Ext.extend(Ext.menu.Menu,
{
    cls: "at-selector-menu",

    constructor: function({
        panel,
        additionalCls,
        disableClickBubble = true,
        parentEl = null,
    })
    {
        this.panel = panel;
        this.disableClickBubble = disableClickBubble
        this.parentEl = parentEl
        if (additionalCls)
        {
            this.cls += " " + additionalCls;
        }
        this.shadow = false;
        SharedUserButtonMenu.superclass.constructor.call(this, {items: [panel]});
        this.panel.on("close", this.hide, this);
    },

    show: function(el, pos, parentMenu)
    {
        // we need to render the panel before calling of this.panel.showCallback(), since it may
        // need to update its content.
        if(!this.el)
            this.render();

        if (this.disableClickBubble)
            $(this.el.dom).off('click').on('click', (e) => e.stopPropagation())

        if (this.panel.showCallback)
            this.panel.showCallback();

        SharedUserButtonMenu.superclass.show.call(this, el, pos, parentMenu);

        var diff = this.el.getBottom() - (getBodyScrollTop() + document.body.clientHeight);
        if (diff > 0) {
            Ext.getBody().scroll("down", diff);
        }
    },

    getSelectorPanel: function()
    {
        return this.panel;
    },

    hide: function()
    {
        if (this.panel.processHide())
        {
            SharedUserButtonMenu.superclass.hide.call(this);
        }
    },

    /*
    following functionality is for reusing one instance of the panel
    for multiple controls
     */
    currentParentId: null,
    states: new AtMap(),

    setStateFor: function(parent, state)
    {
        this.setCurrentParent(parent);
        this.panel.loadState(state);
    },

    switchState: function (parentId, noSwitchState)
    {
        if(!noSwitchState){
            if(this.currentParentId != null)
                this.states.put(this.currentParentId, this.panel.getState());
            if (!this.states.get(parentId))
                this.states.put(parentId, this.panel.createDefaultState(parentId));
        }
        this.currentParentId = parentId;
        if(!noSwitchState)
            this.panel.loadState(this.states.get(parentId));
    },

    setCurrentParent: function (parent, noSwitchState)
    {
        var parentId = parent.id;
        if (this.currentParentId != parentId)
            this.switchState(parentId, noSwitchState);
    },

    isCurrentParent: function(toCheck)
    {
        return this.currentParentId == toCheck.id;
    },

    makeHandlerForSpecificParent: function(parent, callback)
    {
        var self = this;
        return function()
        {
            if (self.isCurrentParent(parent))
                return callback.apply(this, arguments)
        }
    }
});

export default SharedUserButtonMenu;


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/at_shared_user_button_menu.js